import { render, staticRenderFns } from "./GenericUploadForm.vue?vue&type=template&id=31c9a15f&"
import script from "./GenericUploadForm.vue?vue&type=script&lang=js&"
export * from "./GenericUploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports